import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { LoginComponent } from './views/auth/login/login.component';
import { ForgetPasswordComponent } from './views/auth/forget-password/forget-password.component';
import { AuthGuard } from './auth.guard';
import { ChangePasswordComponent } from './views/auth/change-password/change-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'IRMS Login'
    }
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
    data: {
      title: 'Forget Password'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'incident',
        loadChildren: () =>
        import('./views/incidents/incidents.module').then((m) => m.IncidentsModule)
      },
      {
        path: 'services/employee',
        loadChildren: () =>
        import('./views/employees/employees.module').then((m) => m.EmployeesModule)
      },
      {
        path: 'services/officer',
        loadChildren: () =>
        import('./views/officers/officers.module').then((m) => m.OfficersModule)
      },
      {
        path: 'services/staff',
        loadChildren: () =>
        import('./views/staff/staff.module').then((m) => m.StaffModule)
      },
      {
        path: 'services/lostandfound',
        loadChildren: () =>
        import('./views/lost-and-found/lost-and-found.module').then((m) => m.LostAndFoundModule)
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./views/reports/reports.module').then((m) => m.ReportsModule)
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./views/admin-views/categories/categories.module').then((m) => m.CategoriesModule)
      },
      {
        path: 'employer',
        loadChildren: () =>
          import('./views/admin-views/employer/employer.module').then((m) => m.EmployerModule)
      },
      {
        path: 'department',
        loadChildren: () =>
          import('./views/admin-views/department/department.module').then((m) => m.DepartmentModule)
      },
      {
        path: 'nationality',
        loadChildren: () =>
          import('./views/admin-views/nationality/nationality.module').then((m) => m.NationalityModule)
      },
      {
        path: 'injury',
        loadChildren: () =>
          import('./views/admin-views/injury/injury.module').then((m) => m.InjuryModule)
      },
      {
        path: 'service',
        loadChildren: () =>
          import('./views/admin-views/service/service.module').then((m) => m.ServiceModule)
      },
      {
        path: 'area',
        loadChildren: () =>
          import('./views/admin-views/area/area.module').then((m) => m.AreaModule)
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./views/admin-views/user/user.module').then((m) => m.UserModule)
      },
      {
        path: 'program',
        loadChildren: () =>
          import('./views/admin-views/program/program.module').then((m) => m.ProgramModule)
      },
      {
        path: 'items',
        loadChildren: () =>
          import('./views/admin-views/items/items.module').then((m) => m.ItemsModule)
      },
      {
        path: 'unauthorized',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule)
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {path: '**', redirectTo: 'dashboard'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
